import { css } from '@emotion/core'
import styled from '@emotion/styled'
import { FontNormal } from '@css/fonts'
import { fontSize } from '@css/styles'
import {
  lightBlue,
  green,
  black,
  marketingMobileCuttoff, skyBlue, radiantBlue,
} from '@css/constants'

interface InfoBlockContainerProps {
  backgroundColor?: string
}

export const InfoBlockContainer = styled('div')<InfoBlockContainerProps>((props) => css`
  background-color: ${props.backgroundColor === 'green' ? green : (props.backgroundColor === 'skyblue') ? skyBlue : 'white'};
  overflow-x: hidden;
`)

interface InfoBlockContentWrapperProps {
  paddingTop?: string
  paddingTopMobile?: string
  paddingBottom?: string
  paddingBottomMobile?: string
}

interface InfoBlockContentProps {
  mobileReverse?: boolean
}

export const InfoBlockContentWrapper = styled('div')<InfoBlockContentWrapperProps>((props) => css`
  padding-top: ${props.paddingTop || '70px'};
  padding-bottom: ${props.paddingBottom || '70px'};

  @media(max-width: ${marketingMobileCuttoff}) {
    padding-top: ${props.paddingTopMobile || '40px'};
    padding-bottom: ${props.paddingBottomMobile || '40px'};
  }
`)

export const InfoBlockContent = styled('div')<InfoBlockContentProps>((props) => css`
  margin: 0 auto;
  width: 90%;
  max-width: 1000px;

  @media(max-width: ${marketingMobileCuttoff}) {
    width: 100%;
    
    ${props.mobileReverse && `display: flex; flex-flow: column-reverse;`
    
   //mobileReverse
  }
`)

interface InfoBlockHeaderProps {
  backgroundColor?: string
}

export const InfoBlockHeader = styled('div')<InfoBlockHeaderProps>((props) => css`
  @media(max-width: ${marketingMobileCuttoff}) {
    border-left: ${props.backgroundColor === 'green' || props.backgroundColor === 'skyblue' ? 'none' : '10px solid ' + lightBlue};
    padding-left: ${props.backgroundColor === 'green' ? '25px' : '15px'};
  }
`)

export const InfoBlockHeaderContent = styled('div')(css`
`)

interface InfoBlockTextProps {
  textColor?: string
}

export const InfoBlockHeaderTitle = styled('h2')<InfoBlockTextProps>((props) => css`
  ${fontSize(32)};
  ${FontNormal(600)};

  sup {
    ${fontSize(14)};
  }

  color: ${props.textColor || black};

  @media(max-width: ${marketingMobileCuttoff}) {
    ${fontSize(24)};
    padding: 5px 0;
    padding-right: 20px;
  }
`)

export const InfoBlockTextWrapper = styled('div')(css`
  margin-top: 20px;

  @media(max-width: ${marketingMobileCuttoff}) {
    margin-top: 10px;
    margin-left: 10px;
    padding-left: 6px;
  }
`)

export const InfoBlockBottomText = styled('div')(css`
  margin-top: 11px;
  ${FontNormal(400)};
  ${fontSize(16)};
  font-style: italic;
  color: ${black};
  width: 60%;
  
  & > a {
    text-decoration: underline;
    color: ${radiantBlue};
    cursor: pointer;
  }

  @media(max-width: ${marketingMobileCuttoff}) {
    width: auto;
  }
`)

export const InfoBlockSubtitle = styled('p')(css`
  ${fontSize(20)};
  ${FontNormal(600)};
  color: ${black};
  margin-bottom: 10px;
`)

export const InfoBlockText = styled('p')<InfoBlockTextProps>((props) => css`
  ${fontSize(16)};
  ${FontNormal(400)};

  color: ${props.textColor || black};

  @media(max-width: ${marketingMobileCuttoff}) {
    padding-right: 20px;
  }
`)

interface InfoBlockMainSectionProps {
  mainSectionPaddingTopDesktop?: string
  align?: string
  mainSectionMobileWhiteBackground?: boolean
  mobileMainSectionPadding?: boolean
}

export const InfoBlockMainSection = styled('div')<InfoBlockMainSectionProps>((props) => css`
  width: 50%;
  float: ${props.align || 'left'};
  padding-top: ${props.mainSectionPaddingTopDesktop || '0'};

  @media(max-width: ${marketingMobileCuttoff}) {
    width: 100%;
    float: none;
    ${props.mobileMainSectionPadding ? `padding: 40px 0;` : `padding-top: 0;`}    
    ${props.mainSectionMobileWhiteBackground ? `background-color: white;` : '' };
  }
`)

interface InfoBlockMainContentProps {
  mainSectionMaxWidth?: string
  align?: string
}

export const InfoBlockMainContent = styled('div')<InfoBlockMainContentProps>((props) => css`
  max-width: ${props.mainSectionMaxWidth || 'none'};
  float: ${props.align || 'left'};

  @media(max-width: ${marketingMobileCuttoff}) {
    float: none;
  }
`)

interface InfoBlockButtonWrapperProps {
  buttonTextCenter?: boolean
  buttonMinWidth?: boolean
}

export const InfoBlockButtonWrapper = styled('div')<InfoBlockButtonWrapperProps>((props) => css`
  margin-top: 20px;
  ${props.buttonMinWidth ? `width: 78%;` : ''};

  @media(max-width: ${marketingMobileCuttoff}) {
    padding-left: ${props.buttonTextCenter ? '11px' : '16px'};
    margin-bottom: 20px;
    ${props.buttonTextCenter ? `width: 93%; text-align: center;` : ''}
  }
`)

export const InfoBlockLinkWrapper = styled('div')(css`
  margin-top: 20px;

  @media(max-width: ${marketingMobileCuttoff}) {
    padding-left: 25px;
  }
`)

export const InfoBlockLink = styled('p')<InfoBlockTextProps>((props) => css`
  text-decoration: underline;
  ${fontSize(16)};
  ${FontNormal(600)};
  cursor: pointer;

  color: ${props.textColor || lightBlue};
`)

export const InfoBlockSecondarySection = styled('div')(css`
  width: 50%;
  float: left;

  @media(max-width: ${marketingMobileCuttoff}) {
    width: 100%;
    float: none;
  }
`)

export const InfoBlockDisclaimerText = styled('p')<InfoBlockTextProps>((props) => css`
  ${fontSize(14)};
  ${FontNormal(400)};

  width: 90%;
  margin: 0 auto;
  padding-bottom: 15px;
  text-align: center;
  color: ${props.textColor || black};
`)
